import { makeAutoObservable } from 'mobx'

export class NiceSwitch {
  attentionIsRead =
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('attentionNiceIsRead') === 'true'

  visibleAttention = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setVisibleAttention(value: boolean) {
    this.visibleAttention = value
  }

  setAttentionIsRead(value: boolean) {
    this.attentionIsRead = value
  }
}

export const niceSwitch = new NiceSwitch()
